import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { Layout } from "../../ui/layout";
import { ButtonComponent } from "../../ui/molecules/button/newButton";
import { MadfarmInput } from "../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { Pagination } from "../../ui/organisms/pagination";
import { normativa, status } from "../../utils";
import { SOTFilter } from "../sot";
import { getCustomers, resetCustomerCreateRequest, resetCustomersList, resetFindAllCustomersFilters, setFindAllCustomerFilterField, setSelectedCustomerTab } from "./feature/slice";
import { ClientiList } from "./list";

interface Props {
    children: ReactNode
}

export function Clienti() {
    const customerState = useAppSelector(state => state.customer)
    const usersState = useAppSelector(state => state.users)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [activeFilter, setActiveFilter] = useState<'active' | 'inactive' | null>(null);

    useEffect(() => {
        if (usersState.findMeStatus === 'successfully') {
            if (usersState.findMeResponse.headQuarterInfo?.code != 'SC' && usersState.findMeResponse.role !== 'admin') {
                dispatch(setFindAllCustomerFilterField({ field: 'headquarterId', value: usersState.findMeResponse.headQuarterInfo?.id }))
            }
        }
    }, [usersState.findMeStatus])

    return (
        <Layout
            menuItem={MenuItems.CLIENTI}
            breadcrumbItems={['Clienti']}
            headerLabel="Lista Clienti"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Aggiungi Cliente"
                        color={"orange"}
                        onClick={() => {
                            dispatch(resetCustomerCreateRequest())
                            dispatch(setSelectedCustomerTab(0))
                            navigate('/customer')
                        }}
                    />
                </div>
            }
        >
            <div className="flex flex-col min-w-0">
                <div className="flex items-center gap-2">
                    <div className="flex flex-row items-center gap-2 w-full">
                        <div className="w-[40%]">
                            <MadfarmInput
                                placeholder="Cerca Codice Cliente, CUAA o Ragione Sociale"
                                value={customerState.findAllCustomersFilters.search ?? ""}
                                onChangeText={(text) =>
                                    dispatch(setFindAllCustomerFilterField({ field: 'search', value: text }))
                                }
                            />
                        </div>
                        <div className="w-[60%] flex flex-row gap-2 items-center">
                            <SOTFilter
                                key="sot-filter"
                                value={customerState.findAllCustomersFilters.headquarterId ?? null}
                                disabled={usersState.findMeResponse.headQuarterInfo?.code !== 'SC' && usersState.findMeResponse.role !== 'admin'}
                                onChange={(value) => {
                                    dispatch(setFindAllCustomerFilterField({ field: 'headquarterId', value: value }))
                                }}
                            />
                            <MadfarmStaticSelect
                                key="norm-filter"
                                isClearable
                                placeholder={'Norma'}
                                options={normativa}
                                value={customerState.findAllCustomersFilters.norm ?? null}
                                onChange={(value) => {
                                    // @ts-ignore
                                    const normValue = value !== null ? value.value : null;
                                    dispatch(setFindAllCustomerFilterField({ field: 'norm', value: normValue }));
                                }}
                                noOptionsMessage={"Nessuna norma trovata"}
                            />
                            <MadfarmStaticSelect
                                key="status-filter"
                                isClearable
                                placeholder={'Stato'}
                                options={status}
                                value={activeFilter === null ? null : activeFilter}
                                onChange={(value) => {
                                    //@ts-ignore
                                    const newValue = value !== null ? value.value : null;
                                    dispatch(setFindAllCustomerFilterField({ field: 'active', value: newValue }))
                                    if (newValue === 'active' || newValue === 'inactive') {
                                        setActiveFilter(newValue);
                                    }
                                }}
                                noOptionsMessage={"Nessuno stato trovato"}
                            />
                        </div>
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Pulisci"
                            color={"gray"}
                            onClick={() => {
                                dispatch(resetFindAllCustomersFilters())
                                if (usersState.findMeResponse.headQuarterInfo?.code != 'SC' && usersState.findMeResponse.role !== 'admin') {
                                    dispatch(setFindAllCustomerFilterField({ field: 'headquarterId', value: usersState.findMeResponse.headQuarterInfo?.id }))
                                }
                                setActiveFilter(null)
                                dispatch(resetCustomersList())
                            }}
                            fullWidth
                        />
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Cerca"
                            color={"orange"}
                            onClick={() => {
                                dispatch(getCustomers({ ...customerState.findAllCustomersFilters, page: 0, itemsPerPage: 10 }))
                            }}
                            fullWidth
                        />
                    </div>
                </div>
                <Pagination
                    numbResults={customerState.findAllCustomersResponse ? customerState.findAllCustomersResponse.total : 0}
                    pages={customerState.findAllCustomersResponse?.totalPage || 1}
                    currentPage={customerState.findAllCustomersFilters.page ? customerState.findAllCustomersFilters.page : 0}
                    detailsResults={'clienti'}
                    setPage={
                        (page) => {
                            dispatch(setFindAllCustomerFilterField({ field: 'page', value: page }))
                            dispatch(getCustomers(customerState.findAllCustomersFilters))
                        }
                    }
                />
                <ClientiList />
            </div>
        </Layout>
    )
}